import { css } from 'styled-components';

const large = () => css`
  height: 48px;
  padding: 13px 12px;
`;

export { large };
